import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "512",
  height: "512",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.1 19.5c3.5 0 2.3-2.2 2.5-2.8v-1.2c.3 0 .8.3 1.9 1.3 1.6 1.7 2 2.7 3.4 2.7h2.4c.8 0 1.2-.3 1.4-.6s.4-.7.2-1.4c-.5-1.8-3.7-4.7-4-5l.2-.2a28.4 28.4 0 0 0 3.4-6c.2-.6 0-1-.2-1.3-.3-.3-.7-.5-1.3-.5h-2.5c-.8 0-1.4.4-1.7 1.2-.6 1.3-2 4-3.2 5V7.6c0-1.5.2-3-1.4-3H9.3c-1 0-2 1-.9 2.4 1 1.1.3 1.7.5 4.9-.7-.8-2-3-3-5.8-.3-.8-.7-1.5-1.8-1.5H1.6C.6 4.5 0 5 0 6c0 2 4.5 13.5 12.1 13.5M4.1 6c.2 0 .2 0 .4.5 1 2.8 3.1 7.1 4.7 7.1 1.2 0 1.2-1.2 1.2-1.7V8.2c0-1.2-.5-1.8-.8-2.2h3.5v5c0 1.5 1.2 2.3 2.9.5 1.8-2 3.1-5.1 3.2-5.3 0-.1.1-.2.3-.2H22c-.2 1-2.4 4.4-3.2 5.4-.3.6-.6 1.2 0 2l.5.5c.6.7 3 3.1 3.2 4l-2.6.1c-.5 0-.9-.7-2.4-2.2-1.3-1.3-2.2-1.8-3-1.8-1.5 0-1.4 1.2-1.4 2.7v1.2l-1 .1C5.8 18 1.7 8 1.5 6z" }, null, -1)
  ]))]))
}
export default { render: render }